export const nl2br = (str: string, is_xhtml = false) => {
  var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>'
  return (str + '').replace(
    /([^\n\r>]?)(\r\n|\n\r|\r|\n)/g,
    '$1' + breakTag + '$2'
  )
}
